import {
  OverflowMenuHorizontal
} from "@carbon/icons-react";
import { CommonService } from "@Services/common-service";
import DotsThreeVertical from "assets/icons/DotsThreeVertical";
import classNames from "classnames";
import React, { RefObject } from "react";
import "./OverflowMenu.scss";
import OverflowMenuList, { ListOverflowMenu } from "./OverflowMenuList";
import Button from "@Components/Button";

export interface CustomProps {
  /**List object action {name,function} of menu */
  list?: ListOverflowMenu[];
  /**Change the size of button */
  size?: "md" | "xl";
  /**Append this component to body */
  appendToBody?: boolean;
  /**Option to set type vertical or horizontal */
  type?: "vertical" | "horizontal";
  /**option change style type of overflowMenu */
  isActionRowTable?: boolean;
  /**Option to set not allow to click Component */
  disabled?: boolean;
}

function OverflowMenu(props: CustomProps) {
  const { size = "md", list, type = "vertical", disabled, isActionRowTable = true } = props;

  const [isExpand, setExpand] = React.useState<boolean>(false);

  const [appendToBodyStyle, setAppendToBodyStyle] = React.useState({});

  const wrapperRef: RefObject<HTMLDivElement> = React.useRef<HTMLDivElement>(
    null
  );

  const buttonRef: RefObject<HTMLDivElement> = React.useRef<HTMLDivElement>(
    null
  );

  const selectListRef: RefObject<HTMLDivElement> = React.useRef<HTMLDivElement>(
    null
  );

  const [floatingDirection, setFloatingDirection] = React.useState<
    "top" | "bottom"
  >("top");

  const handleExpand = React.useCallback(() => {
    setExpand(true);
  }, []);

  // // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const handleKeyDown = React.useCallback((event: any) => {
    switch (event.keyCode) {
      case 40:
        // eslint-disable-next-line no-case-declarations
        const firstItem = selectListRef.current
          .firstElementChild as HTMLElement;
        firstItem.focus();
        break;
      case 9:
        setExpand(false);
        break;
      default:
        return;
    }
  }, []);

  const [check, setCheck] = React.useState<boolean>(true);

  React.useEffect(() => {
    if (isExpand && check && buttonRef?.current) {
      const currentPosition = buttonRef?.current?.getBoundingClientRect();
      const heightOfList = selectListRef.current.clientHeight;
      const spaceBelow = window.innerHeight - currentPosition.bottom;
      if (spaceBelow <= 200) {
        setAppendToBodyStyle({
          position: "absolute",
          top: currentPosition.top - heightOfList,
          right: window.innerWidth - currentPosition.right,
        });
        setFloatingDirection("bottom");
      } else {
        if (size === "md") {
          setAppendToBodyStyle({
            position: "absolute",
            top: currentPosition.top + 32,
            right: window.innerWidth - currentPosition.right,
          });
        } else {
          setAppendToBodyStyle({
            position: "absolute",
            top: currentPosition.top + 40,
            right: window.innerWidth - currentPosition.right,
          });
        }
        setFloatingDirection("top");
      }
      setCheck(false);
    }
  }, [appendToBodyStyle, check, isExpand, size]);

  const handleCloseList = React.useCallback(() => {
    setExpand(false);
    setCheck(true);
  }, []);

  CommonService.useClickOutside(selectListRef, handleCloseList);

  return (
    <div className="overflow-menu__container" ref={wrapperRef}>
      <div
        className={classNames("overflow-menu__button", {
          "overflow-menu__button--md": size === "md",
          "overflow-menu__button--xl": size === "xl",
        })}
        ref={buttonRef}
      >
        {isActionRowTable ? (
          <button
            className={classNames(
              "btn-component btn-only-icon button-overflow-menu",
              {
                "btn--md": size === "md",
                "btn--xl": size === "xl",
                "btn--shadow": isExpand,
                "overflow-menu--disabled": disabled,
              }
            )}
            onClick={handleExpand}
            onKeyDown={handleKeyDown}
            disabled={disabled}
          >
            {type === "vertical" ? (
              <DotsThreeVertical />
            ) : (
              <OverflowMenuHorizontal size={16} />
            )}
          </button>
        ) : (
          <Button
            size="sm"
            type="icon-secondary"
            icon={type === "vertical" ? <DotsThreeVertical /> : <OverflowMenuHorizontal size={16} />}
            onClick={handleExpand}
            disabled={disabled}
            iconPlace="both"
          >
          </Button>
        )}



      </div>
      {isExpand && (
        <OverflowMenuList
          setExpand={setExpand}
          list={list}
          selectListRef={selectListRef}
          appendToBodyStyle={appendToBodyStyle}
          size={size}
          floatingDirection={floatingDirection}
        />
      )}
    </div>
  );
}
export default OverflowMenu;
